import React from "react";
import { GoDotFill } from "react-icons/go";
import styles from "./styles.module.scss";

const CustomDot = ({ onClick, ...rest }) => {
    const {
        index,
        active,
        hiddenDotsRef
        // carouselState: { currentSlide, deviceType }
    } = rest;
    return (
        <button
            ref={(el) => (hiddenDotsRef.current[index] = el)}
            className={`${styles.dot} ${active ? styles.active : styles.inactive}`}
            onClick={() => onClick()}
        >
            <GoDotFill />
        </button>
    );
};

export { CustomDot };